export const floatingVueConfig = {
  container: 'body',
  modalContainer: document.querySelector('body'),
  stepsContainer: document.querySelector('body'),
  themes: {
    tooltip: {
      placement: 'top',
      triggers: ['hover', 'touch', 'click'],
      popperTriggers: ['hover'],
      delay: {
        show: 200,
        hide: 200,
      },
      loadingContent: '...',
    },
    'cta-tooltip': {
      $extend: 'tooltip',
      placement: 'top',
      html: true,
      $resetCss: true,
      delay: { show: 300, hide: 300 },
    },
    'cfc-tooltip': {
      $extend: 'tooltip',
      placement: 'right',
      html: true,
      $resetCss: true,
    },
  },
}
